export const APP_LOADING = 'APP_LOADING';